import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {CommonItemDetailsComponent} from '@emm/common-items/components/common-item-details/common-item-details.component';
import {Router} from '@angular/router';
import {openCommonItemInReact} from '@emm/core/util/common-item-url.util';

@Component({
    selector: 'emm-common-item',
    templateUrl: './common-item.component.html',
    styleUrl: './common-item.component.scss',
    standalone: false
})
export class CommonItemComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() selectedItem: any;
    @Input() selectedFeatureScope: string;
    @Input() selectedLocation: string;
    @Input() selectedConsumer: string;
    @Input() selectedSubmenu;
    isReadOnly = true;
    isLoading = false;
    context$ = new BehaviorSubject<{
        featureScope: string;
        location: string;
        submenu: string;
        consumer?: string;
    } | null>(null);
    private destroy$ = new Subject<void>();

    @ViewChild(CommonItemDetailsComponent) itemDetailComponent: CommonItemDetailsComponent;

    constructor(
        private router: Router,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.context$.next({
            featureScope: this.selectedFeatureScope,
            location: this.selectedLocation,
            consumer: this.selectedConsumer,
            submenu: this.selectedSubmenu,
        });
    }

    ngAfterViewInit() {
        this.cdr.detectChanges();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    editCommonItem() {
        const itemClass = this.selectedItem.class || this.selectedItem.objectType;
        openCommonItemInReact(this.router, itemClass, this.selectedItem.tag);
    }
}
